module.exports = __webpack_public_path__ + "static/media/1.ce37eca0.png";